import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { FC } from 'react'

import { useSelector } from 'react-redux'

import { Tabs, Tab } from '@material-ui/core'

import { getRole } from '~/state/modules/user'

import { ROLES } from '~/constants/roles'
import ROUTES from '~/constants/routes'

import { useHeaderTabsArray } from './HeaderTabs.config'
import { useHeaderTabsStyles } from './HeaderTabs.styles'

const HeaderTabs: FC<HeaderProps> = ({ incomingMessages }) => {
  const s = useHeaderTabsStyles()

  const HeaderTabsArray = useHeaderTabsArray()

  const router = useRouter()
  const role = useSelector(getRole)

  const handleChangeTab = (
    _event: React.ChangeEvent<{}>,
    value: string
  ): void => {
    router.push(value)
  }

  return (
    <Tabs
      classes={{
        root: s.root,
        indicator: s.indicator
      }}
      indicatorColor="primary"
      value={router.pathname}
      onChange={handleChangeTab}
      variant="scrollable"
    >
      {HeaderTabsArray.map((tab) => {
        if (role === ROLES.clinic && tab.value === ROUTES.clinics) return null

        return (
          <Tab
            component={(props): JSX.Element => (
              <Link href={tab.value} passHref>
                {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                <a {...props} />
              </Link>
            )}
            label={tab.label}
            value={tab.value}
            key={tab.value}
            classes={{
              root: s.tab,
              selected: s.selected
            }}
            className={
              incomingMessages &&
              tab.value === ROUTES.referrals &&
              s.notification
            }
          />
        )
      })}
    </Tabs>
  )
}

export default HeaderTabs
